import { create, show, useModal } from "@ebay/nice-modal-react";
import { useCallback, useEffect, useId, useRef } from "react";

import Button from "ds/components/Button";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import Modal from "ds/components/Modal";
import ModalCancelButton from "ds/components/Modal/CancelButton";
import ModalContent from "ds/components/Modal/Content";
import ModalFooter from "ds/components/Modal/Footer";
import ModalHeader from "ds/components/Modal/Header";

const SpacesSpaceSwitchLeaveModal = create(function SpacesSpaceSwitchLeaveModal() {
  const modal = useModal();
  const contentId = useId();
  const resolvedRef = useRef(false);

  useEffect(() => {
    if (modal.visible) {
      resolvedRef.current = false;
    }
  }, [modal.visible]);

  const handleConfirm = useCallback(() => {
    if (resolvedRef.current) {
      return;
    }
    resolvedRef.current = true;
    modal.resolve(true);
    modal.hide();
  }, [modal]);

  const handleDismiss = useCallback(() => {
    if (resolvedRef.current) {
      return;
    }
    resolvedRef.current = true;
    modal.resolve(false);
    modal.hide();
  }, [modal]);

  return (
    <Modal
      shouldIgnoreOutsideClick
      role="alertdialog"
      ariaDescribedBy={contentId}
      isOpen={modal.visible}
      onClose={handleDismiss}
      onExit={modal.remove}
      isDismissable
    >
      <ModalHeader title="Discard changes" />
      <ModalContent id={contentId}>
        <ConfirmationModalMessage>
          Do you really want to leave? <strong>Changes won’t be saved.</strong>
        </ConfirmationModalMessage>
      </ModalContent>
      <ModalFooter>
        <ModalCancelButton onClick={handleDismiss} />
        <Button variant="dangerPrimary" onPress={handleConfirm}>
          Leave
        </Button>
      </ModalFooter>
    </Modal>
  );
});

SpacesSpaceSwitchLeaveModal.displayName = "Spaces.SpacesSpaceSwitchLeaveModal";

export default function showSpacesSpaceSwitchLeaveConfirmation(): Promise<boolean> {
  return show(SpacesSpaceSwitchLeaveModal) as Promise<boolean>;
}
